import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import SlidewordsHUD from "./SlidewordsHUD";
import BaseSlidewords from "./BaseSlidewords";
import {
  getPonderStreakFromStorage,
  updatePonderStreak,
  getIsPonderStreakActive,
} from "../components/PonderStreakUtil";
import StreakCounter from "../../../components/StreakCounter";

const coffeeWords = ["ESPRESSO", "CORTADO", "AMERICANO", "ROAST", "AFFOGATO"];

const GAME_ID = "slidewords-coffee";
const BEST_SCORE_KEY = "slidewords-coffee-bestScore";

const CoffeeSlidewords = () => {
  const [wordsFound, setWordsFound] = useState(0);
  const [bestWords, setBestWords] = useState(() => {
    const saved = localStorage.getItem(BEST_SCORE_KEY);
    return saved ? parseInt(saved, 10) : 0;
  });
  const [attempts, setAttempts] = useState(0);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [streak, setStreak] = useState(0);
  const [isStreakActive, setIsStreakActive] = useState(false);
  const [showHowTo, setShowHowTo] = useState(false);
  const [showStreakModal, setShowStreakModal] = useState(false);
  const [isMuted, setIsMuted] = useState(false);

  // Update streak on mount and date change
  useEffect(() => {
    const { count } = getPonderStreakFromStorage(GAME_ID);
    setStreak(count);
    setIsStreakActive(getIsPonderStreakActive(GAME_ID));
  }, [currentDate]);

  // Update best words if wordsFound increases
  useEffect(() => {
    if (wordsFound > bestWords) {
      setBestWords(wordsFound);
      localStorage.setItem(BEST_SCORE_KEY, wordsFound.toString());
    }
  }, [wordsFound, bestWords]);

  // Handlers for HUD
  const handleHelp = () => setShowHowTo(true);
  const handleStreakClick = () => setShowStreakModal(true);
  const handleDateClick = null; // Not implemented for now
  const handleMute = () => setIsMuted(!isMuted);

  // Callback for BaseSlidewords to update HUD state
  const handleGameUpdate = ({ score, guesses, attempts }) => {
    setWordsFound(score); // score is now wordsFound
    setAttempts(attempts);
  };

  return (
    <Box sx={{ bgcolor: "#f5f3ee", minHeight: "100vh", p: { xs: 0.5, sm: 1 } }}>
      <Paper
        elevation={2}
        sx={{
          width: "100%",
          maxWidth: "sm",
          p: { xs: 1.5, sm: 2 },
          mb: { xs: 1.5, sm: 2 },
          borderRadius: 2,
          bgcolor: "white",
          mx: "auto",
        }}
      >
        <SlidewordsHUD
          wordsFound={wordsFound}
          bestWords={bestWords}
          goalWords={2}
          currentDate={currentDate}
          streak={streak}
          isStreakActive={isStreakActive}
          onHelp={handleHelp}
          onDateClick={handleDateClick}
          onStreakClick={handleStreakClick}
          totalWords={5}
          isMuted={isMuted}
          onMute={handleMute}
        />
      </Paper>
      <BaseSlidewords
        customTitle="Coffee Slidewords"
        subtitle="Slide the coffee words to form as many valid words as you can!"
        wordList={coffeeWords}
        goalWords={2}
        buttonColor="#6f4e37"
        modalBackgroundColor="#f5f3ee"
        backgroundColor="#f5f3ee"
        maxAttempts={20}
        onGameUpdate={handleGameUpdate}
        showHowToOverride={showHowTo}
        setShowHowToOverride={setShowHowTo}
        allPossibleWords={["PROOF", "ROAST", "ROOST", "SCARF", "START"]}
        isMuted={isMuted}
      />
    </Box>
  );
};

export default CoffeeSlidewords;
